var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpinnerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1H7v4h2V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7v4h2v-4Z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9V7h-4v2h4Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9V7H1v2h4Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.668 3.757-1.415-1.415-2.828 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.575 10.827 5.16 9.412l-2.829 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.329 13.753 1.414-1.414-2.998-2.998-1.414 1.414 2.998 2.998Z",
    opacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h14v14H1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinnerLight);
export default __webpack_public_path__ + "static/media/icon-spinner-light.5b8cd3f3b1a90619c6c01aefe91023e8.svg";
export { ForwardRef as ReactComponent };